namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailKonfiguraceJadraGinis extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GKonfiguraceJadraGinisDto;
        private newRecord: boolean;
        //private detailObj: DetailKonfiguraceJadraGinisObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            builder.withComponent<this>("DetailKonfiguraceJadraGinis", {
                //headerForm: this.headerForm(),
                actions: this.createActions(),
                tabGroups: this.createTabGroups(),
                tabs: this.createTabs(),
                menuBar: this.createMenuBar()
            })
        }

        private createTabGroups(): IGTabGroupOptions[] {
            var tabGroups: IGTabGroupOptions[] = [];
            tabGroups.push({ id: "_tabSetting", caption: "jres:33000195" }) //RC 33000195 : Nastavení systému
            tabGroups.push({ id: "_tabDbInfo", caption: "jres:33000207" }) //RC 33000207 : Informace o DB
            tabGroups.push({ id: "_tabPodpora", caption: "jres:33000232" }) //RC 33000207 : Informace o DB
            return tabGroups;
        }

        private createTabs(): Gordic.Gin.DetailBuilder.TabParamsId[] {
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] = [];
            tabs.push({
                tabParams: {
                    id: "_tabSettings",
                    title: "jres:33000196", //RC 33000196 : Nastavení systému
                    opened: true,
                    locked: true,
                    group: { id: "_tabSetting" },
                    menuBar: []
                },
                init: (tab) => {
                    this.createTabSetting(tab);
                }
            })
            tabs.push({
                tabParams: {
                    id: "_tabDbInfo",
                    title: "jres:33000207", //RC 33000196 : Nastavení systému
                    opened: true,
                    locked: true,
                    group: { id: "_tabDbInfo" },
                    menuBar: []
                },
                init: (tab) => {
                    this.createDbInfoTab(tab);
                }
            })
            tabs.push({
                tabParams: {
                    id: "_tabPodpora",
                    title: "jres:33000232", //RC 33000232 : Podpora
                    opened: true,
                    locked: true,
                    group: { id: "_tabPodpora" },
                    menuBar: []
                },
                init: (tab) => {
                    this.createPodporaTab(tab);
                }
            })
            return tabs;
        }

        private createActions(): (GActionParams | GAction)[] | ObjectLiteral<GActionParamsDefObj | GAction> | null {
            return {
                actBaseAction: {
                    caption: "jres:33000194", //RC 33000194 : Nastavení jádra systému GINIS
                    run: (ev, ctx) => {
                        this.tryCloseAllChildContents();
                    }
                },
                actWarningDemo: {
                    caption: "",
                    run: (ev, ctx) => {
                        this.dialogs.warning("jres:32000149", "jres:33000209") //RC 33000209 : POZOR!;Tetno příznak má zásadní význam pro chod systému a nesmí se bezdůvodně měnit. ;Změnu tohoto atributu je nutné důsledně zvážit. ;Zapnutí parametru je možné pouze v souladu s poskynutou licencí pro el.úložiště.
                    }
                },
                actOpenSeznamAdmObsahLicCert: {
                    caption: "jres:29930142",
                    icon: "gi-key",
                    run: (ev, ctx) => {
                        this.openObsahLicCert();
                    }
                },
                
            }
        }

        private createMenuBar() {
            return ["actOpenSeznamAdmObsahLicCert*"]
        }

        private headerForm(): Gordic.Forms.Form {
            var form = new Gordic.Forms.Form()
                .addRow("jres:33000197").addField("gstringbox", "w-6", { //RC 33000197 : Licence DB
                    name: "lic"
                })
                .addRow("jres:33000198").addField("gstringbox", "w-6", { //RC 33000198 : Typ CFU
                    name: "tyi"
                })
                .addRow("jres:29930689").addField("gstringbox", {
                    name: "poznamka"
                })
                .addRow("jres:33000199").addField("gselectbox", Gordic.Prefabs.Select.gincpan(), {
                    name: "priz_d",
                    dropdown: true,
                    tooltip: "jres:33000200", //RC 33000200 : Příznak zda je databáze určena pro školení, testování, demo verze a prezentační činnost. ; Ostrá DB musí být graficky rozlišená od tzv. DEMO kopií, aby uživatelé nepořizovali záznamy do jiné databáze.
                    model: "model.priz_d=value.priz_an",
                    tag: {
                        text: "jres:33000208", //RC 33000208 : Příznak ovlivňuje chod systému. Klikněte pro podrobnosti.
                        state: "important",
                        action: this.actions.actWarningDemo
                    }
                })
                .addRow("jres:33000201").addField("gdatebox", "w-6", { //RC 33000201 : Přepnuto na DEMO databázi od
                    name: "dat_test_od",
                    valueType: "datetime",
                })
                .addRow("jres:33000202").addField("gselectbox", Gordic.Prefabs.Select.gincpan(), { //RC 33000202 : Bez kontroly souběžného přihlášení
                    name: "priz_f",
                    dropdown: true,
                    model: "model.priz_f=value.priz_an"
                })
                .addRow("jres:33000203").addField("gselectbox", Gordic.Prefabs.Select.gincpan(), { //RC 33000203 : Povolení subsystému el. úložišť
                    name: "priz_ele",
                    dropdown: true,
                    model: "model.priz_ele=value.priz_an"
                })
                .addRow("jres:33000204").addField("gselectbox", Gordic.Prefabs.Select.gincpan(), { //RC 33000204 : Povolení událostního systému
                    name: "s_gor_event",
                    dropdown: true,
                    model: "model.s_gor_event=value.priz_an"
                })
                .addRow("jres:33000205").addField("gselectbox", Gordic.Prefabs.Select.gincpan(), { //RC 33000205 : Povolení užití fulltextu el. úložiště
                    name: "priz_ftx",
                    dropdown: true,
                    model: "model.priz_ftx=value.priz_an"
                })
                .addRow("jres:33000206").addField("gselectbox", Gordic.Prefabs.Select.gincpan(), { //RC 33000206 : Vícefaktorové autentizace
                    name: "priz_totp",
                    dropdown: true,
                    model: "model.priz_totp=value.priz_an"
                })
            return form;
        }

        private createTabSetting(tab) {
            var form = $("<div>").gform("createFrom", this.headerForm()).appendTo(tab);
            form.findFields("lic", "tyi", "priz_ele", "priz_ftx", "s_gor_event").gfield("disable")
            form.findFields().gfield("model", "apply", this.data)
        }

        private createDbForm(): Gordic.Forms.Form {
            return new Gordic.Forms.Form({ name: "form-db-info" })
                .addRow("jres:33000210").addField("gdatebox", "w-6", { //RC 33000210 : Vznik DB
                    name: "dat_vznik_db",
                    valueType: "datetime",
                })
                .addRow("jres:33000211").addField("gstringbox", "w-6", { //RC 33000211 : Verze DB
                    name: "verze_db_kompl",
                    model: function (op, dto, modelOpt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", "{0}XXX{1}x{2}".format(dto.verze_db, dto.sub_verze_db.toString().padStart(3, "0"), dto.revize_adz.toString().padStart(2, "0")));
                            break;
                        }
                    }
                })
                .addRow("jres:33000212").addField("gstringbox", "w-6", { //RC 33000212 : Verze posl. řádného ADZ
                    name: "sub_verze_adz",
                    model: function (op, dto, modelOpt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", "{0}XXX{1}".format(dto.veze_db, dto.sub_verze_adz.toString().padStart(3, "0")))
                            break;
                        }
                    }
                })
                // Totot skrýt
                .addRow("jres:33000213").addField("gstringbox", "w-6", { //RC 33000213 : MSM verze DB
                    name: "sub_verze_dbo",
                    model: function (op, dto, modelOpt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", "248.{0}.".format(dto.sub_verze_dbo));
                                break;
                        }
                    }
                })
                .addRow("jres:33000214").addField("gstringbox", "w-6", { //RC 33000214 : XX databáze
                    name: "xxdb"
                })
                // KONEC toto skrýt
                .addRow("jres:33000215").addField("gstringbox", "w-6", { //RC 33000215 : DB server (fyz.)
                    name: "servername"
                })
                .addRow("jres:33000216").addField("gstringbox", "w-6", { //RC 33000216 : Databáze (fyz.)
                    name: "db_name"
                })
                .addRow("jres:33000217").addField("gselectbox", "w-6", Gordic.Prefabs.Select.gincpan(), { //RC 33000217 : Cluster server
                    name: "priz_cluster",
                    dropdown: true,
                    model: "model.priz_cluster=value.priz_an"
                })
                .addRow("jres:33000218").addField("gdatebox", "w-6", { //RC 33000218 : Poslední restart DB
                    name: "dat_last_reboot",
                    valueType: "datetime"
                })
                .addRow("jres:33000219").addField("gdatebox", "w-6", { // SELECT MAX(dat_zmena) FROM vas.ginlser WHERE id_akce LIKE '%XXX%'  //RC 33000219 : Poslední reinstalace
                    name: "dat_reinst",
                    valueType: "datetime"
                })
                .addRow("jres:33000220").addField("gdatebox", "w-6", { // ?? //RC 33000220 : Poslední zálohování
                    name: "dat_last_backup",
                    valueType: "datetime"
                })
                .addRow("jres:33000221").addField("gdatebox", "w-6", { // ?? //RC 33000221 : Poslední obnovení
                    name: "dat_last_restore",
                    valueType: "datetime"
                })
                .addRow("jres:33000222").addField("gstringbox", { //RC 33000222 : Verze DB ser.
                    name: "serv_verz",
                    rows: 5
                })
                .addRow("jres:33000223").addField("gcheck", { //RC 33000223 : Příznak UNICODE
                    name: "priz_unicode",
                    model: function (op, dto, dtoOpt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", dto.priz_unicode == 1);
                                break;
                        }
                    }
                })
                .addRow("jres:33000224").addField("gcheck", { //RC 33000224 : Příznak AZURE
                    name: "priz_azure",
                    model: function (op, dto, dtoOpt) {
                        switch (op) {
                            case "apply":
                                $(this).gfield("setValue", dto.priz_azure == 1);
                                break;
                        }
                    }
                })
                //.addRow("Příznak odpojování").addField("gcheck", {
                //    name: "priz_disconnect",
                //})
        }

        private createDbInfoTab(tab) {
            var form = $("<div>").gform("createFrom", this.createDbForm()).appendTo(tab);
            form.findFields().gfield("disable");
            form.findFields("priz_cluster").gfield("enable")
            form.findFields().gfield("model", "apply", this.data)
        }

        private createPodporaForm() {
            return new Gordic.Forms.Form({ name: "podpora-form" })
                .addRow("jres:33000225").addField("gstringbox", { //RC 33000225 : Mailová adresa pro zasílání hlášení o chybách
                    name: "err_mail"
                })
                .addRow("jres:33000226").addField("gstringbox", { //RC 33000226 : Mailové adresy implemetátora pro řešení chyb v modulech
                    name: "mail_chyby"
                })
                .addRow("jres:33000227").addField("gstringbox", { //RC 33000227 : Jména a telefonní čísla implementátora pro řešení chyb v modulech
                    name: "tel_chyby"
                })
                .addRow("jres:33000228").addField("gstringbox", { //RC 33000228 : Poznámka k implementaci, důležitá pro řešení chyb v modulech
                    name: "pozn_chyby"
                })
                .addRow("jres:33000229").addField("gstringbox", { //RC 33000229 : URL www stránek výrobce
                    name: "url_gordic"
                })
                .addRow("jres:33000230").addField("gstringbox", { //RC 33000230 : URL popisu změn aplikací
                    name: "url_histxml"
                })
                .addRow("jres:33000231").addField("gstringbox", { //RC 33000231 : URL interního popisu změn aplikací
                    name: "url_histxmldebug"
                })
        }

        private createPodporaTab(tab) {
            var form = $("<div>").gform("createFrom", this.createPodporaForm()).appendTo(tab);
            form.findFields().gfield("model", "apply", this.data)
        }

        private openObsahLicCert() {
            this.navigate(["Gordic.Adm.WebControls.SeznamAdmObsahLicCert"], { Id: "SeznamAdmObsahLicCert" });
        }

        onContentReady() {
            this.setBreadcrumbs({
                action: this.actions.actBaseAction
            })
        }

        closing() {
            
        }
    }
}